"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.id = id;
var idCounter = 0;
function id() {
    return idCounter++;
}
